import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbItem } from '../models/breadcrumb.model';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbs = new BehaviorSubject<BreadcrumbItem[]>([]);
  breadcrumbs$ = this.breadcrumbs.asObservable();
  history: string[] = [];

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.history.push(event.url);
      }
    });
  }
  
  setBreadcrumbs(items: BreadcrumbItem[]) {
    this.breadcrumbs.next(items);
  }

  getPreviousUrl(): string {
    return this.history.length > 1
      ? this.history[this.history.length - 2]
      : '/';
  }
}